import { StatusChipColor } from "components/StatusChip";

export function confidenceColor(confidence: string): StatusChipColor {
  if (confidence === "high") return "success";
  if (confidence === "medium") return "warning";
  return "default";
}
